const TEMPLATE_PREFIX = 'bmg-campaign-sandbox-template-v1:';
const MAX_SANDBOX_PERSONAS = 4;

const storageKey = (campaignId) => `${TEMPLATE_PREFIX}${campaignId}`;

const clampPersonaCount = (value) => {
  const parsed = Math.floor(Number(value) || 0);
  return Math.max(0, Math.min(MAX_SANDBOX_PERSONAS, parsed));
};

const clonePlainObject = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, entry === true]));
};

export const buildCampaignSandboxTemplateFromForm = (form = {}) => {
  const presetCategories = clonePlainObject(
    form.testPresetCategories || form.testCharacterPresetCategories,
  );
  return {
    version: 1,
    personaCount: clampPersonaCount(form.dummyCount),
    presetCategories,
  };
};

export const saveCampaignSandboxTemplate = (campaignId, form = {}, storage = null) => {
  if (!campaignId) return false;
  try {
    const targetStorage = storage || (typeof window !== 'undefined' ? window.localStorage : null);
    if (!targetStorage) return false;
    targetStorage.setItem(
      storageKey(campaignId),
      JSON.stringify(buildCampaignSandboxTemplateFromForm(form)),
    );
    return true;
  } catch (_) {
    return false;
  }
};

export const loadCampaignSandboxTemplate = (campaignId, storage = null) => {
  if (!campaignId) return null;
  try {
    const targetStorage = storage || (typeof window !== 'undefined' ? window.localStorage : null);
    if (!targetStorage) return null;
    const raw = targetStorage.getItem(storageKey(campaignId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      version: parsed.version === 1 ? 1 : 1,
      personaCount: clampPersonaCount(parsed.personaCount),
      presetCategories: clonePlainObject(parsed.presetCategories),
    };
  } catch (_) {
    return null;
  }
};
